import React from "react";
import LegalLayout, { LegalSection, LegalSub, LegalList, LegalCallout, Field } from "../../components/LegalLayout";
import SEO from "../../components/SEO";
import { COMPANY } from "../../config/COMPANY-INFO";

export default function ComplaintsPage() {
  return (
    <>
      <SEO
        title="Reklamační řád"
        description="Postup pro uplatnění reklamace detailingové služby u Apex Detailing v Praze a okolí."
        path="/pravni/reklamacni-rad"
      />
      <LegalLayout
      title="Reklamační řád"
      subtitle="Postup pro uplatnění reklamace detailingové služby."
      testId="page-complaints"
    >
      <LegalSection id="provozovatel" title="1. Provozovatel">
        <LegalList>
          <li>Jméno / Obchodní firma: <Field value={COMPANY.legalName} name="jméno" /></li>
          <li>IČO: <Field value={COMPANY.ico} name="IČO" /></li>
          <li>Sídlo / místo podnikání: <strong>{COMPANY.address.full}</strong></li>
          <li>E-mail: <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a></li>
          <li>Telefon: <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a></li>
        </LegalList>
      </LegalSection>

      <LegalSection id="rozsah" title="2. Rozsah platnosti">
        <p>
          Tento reklamační řád upravuje způsob a podmínky reklamace vad detailingových služeb (mytí, čištění interiéru, kompletní detailing, doplňkové služby) poskytnutých Poskytovatelem na základě objednávky uzavřené prostřednictvím webu, telefonicky, zprávou nebo osobně.
        </p>
        <p>Reklamační řád se vztahuje pouze na vztahy se spotřebiteli (zákazníci, kteří službu objednávají mimo svou podnikatelskou činnost). Vztahy s podnikateli se řídí příslušnými ustanoveními občanského zákoníku.</p>
      </LegalSection>

      <LegalSection id="prava" title="3. Práva z vadného plnění">
        <p>Pokud poskytnutá služba neodpovídá smluvenému rozsahu nebo má jiné vady (nedokončené čištění, viditelné nečistoty, poškození vozidla vzniklé v průběhu detailingu apod.), má Zákazník právo na:</p>
        <LegalList>
          <li><strong>bezplatné odstranění vady</strong> opětovným provedením dané části služby v přiměřené lhůtě, nebo</li>
          <li><strong>přiměřenou slevu z ceny</strong>, pokud vadu nelze odstranit nebo její odstranění by bylo neúčelné, případně</li>
          <li><strong>odstoupení od smlouvy</strong>, jde-li o vadu podstatnou a Poskytovatel ji ani v náhradní lhůtě neodstraní.</li>
        </LegalList>
      </LegalSection>

      <LegalSection id="postup" title="4. Postup uplatnění reklamace">
        <LegalSub title="4.1 Při převzetí vozidla">
          <p>
            Doporučujeme zkontrolovat výsledek služby <strong>ihned při převzetí vozidla</strong>. Případné zjevné vady (např. opomenuté místo, šmouhy, neuklizený drobný odpad) je nejlepší vyřešit na místě — Poskytovatel provede nápravu okamžitě.
          </p>
        </LegalSub>
        <LegalSub title="4.2 Pozdější reklamace">
          <p>Vady, které nebylo možné rozpoznat při převzetí, lze uplatnit písemně:</p>
          <LegalList>
            <li>E-mailem na <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a></li>
            <li>Osobně nebo poštou na adrese sídla: <strong>{COMPANY.address.full}</strong> (osobní předání po předchozí domluvě telefonicky nebo e-mailem)</li>
            <li>Telefonicky: <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a> (pro rychlou koordinaci; písemné potvrzení následně zašlete e-mailem)</li>
          </LegalList>
          <p>K reklamaci je třeba uvést:</p>
          <LegalList>
            <li>identifikační údaje zákazníka a kontaktní e-mail</li>
            <li>datum a čas provedení služby (nebo číslo / odkaz na rezervaci)</li>
            <li>popis vady (slovně + ideálně fotodokumentace)</li>
            <li>uplatňované právo (oprava / sleva / odstoupení)</li>
          </LegalList>
        </LegalSub>
        <LegalSub title="4.3 Lhůta pro uplatnění">
          <p>
            Zákazník může vadu služby vytknout v zákonné lhůtě. Poskytovatel doporučuje uplatnit reklamaci bez zbytečného odkladu poté, co Zákazník vadu zjistí — u detailingových služeb se stav vozidla přirozeně mění běžným provozem a pozdější uplatnění může ztížit posouzení, zda vada vznikla při poskytnutí služby. K posouzení reklamace slouží zejména vstupní a výstupní fotodokumentace pořízená Poskytovatelem při předání vozidla.
          </p>
        </LegalSub>
      </LegalSection>

      <LegalSection id="vyrizeni" title="5. Vyřízení reklamace">
        <p>
          Poskytovatel reklamaci posoudí <strong>bez zbytečného odkladu</strong>, nejpozději <strong>do 3 pracovních dnů</strong> od jejího přijetí, a vyřídí ji včetně případného odstranění vady <strong>do 30 dnů</strong> od přijetí (delší lhůta jen po písemné dohodě se zákazníkem).
        </p>
        <p>O výsledku reklamace bude Zákazník informován e-mailem na adresu uvedenou v reklamaci. V případě uznané reklamace dohodne Poskytovatel se Zákazníkem termín opravy nebo způsob vrácení části / celé ceny.</p>
      </LegalSection>

      <LegalSection id="vyluky" title="6. Vyloučení z reklamace">
        <p>Reklamace se nevztahuje na:</p>
        <LegalList>
          <li>vady vzniklé v důsledku běžného opotřebení vozidla nebo jeho nesprávným užíváním po předání</li>
          <li>poškození laku, plastů nebo interiéru, které existovalo již před zahájením služby a bylo zaznamenáno ve vstupní kontrole</li>
          <li>kosmetické nedokonalosti, které jsou vlastnostmi materiálu (např. mikroškrábance na laku, opotřebená kůže)</li>
          <li>vady způsobené neodborným zásahem třetí osoby po předání vozidla</li>
        </LegalList>
      </LegalSection>

      <LegalSection id="adr" title="7. Mimosoudní řešení sporu">
        <p>
          Pokud nedojde k vyřešení reklamace ke spokojenosti Zákazníka, má Zákazník (jako spotřebitel) možnost obrátit se na <strong>Českou obchodní inspekci</strong> jakožto subjekt mimosoudního řešení sporů — viz{" "}
          <a href="/pravni/reseni-sporu" className="text-apex-gold hover:underline">stránka ADR</a>.
        </p>
        <LegalCallout>
          Tento reklamační řád nabývá účinnosti dnem <strong>{COMPANY.effectiveDate}</strong>.
        </LegalCallout>
      </LegalSection>
    </LegalLayout>
    </>
  );
}
